import { render, staticRenderFns } from "./GoodsCategory.vue?vue&type=template&id=3bde8cf3&scoped=true&"
import script from "./GoodsCategory.vue?vue&type=script&lang=js&"
export * from "./GoodsCategory.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCategory.vue?vue&type=style&index=0&id=3bde8cf3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bde8cf3",
  null
  
)

export default component.exports